export enum UserPermission {
    Authenticated = 'authenticated',

    ReportsRead = 'reports:read',
    ReportsWrite = 'reports:write',
    ReportsDelete = 'reports:delete',

    DocumentsWrite = 'documents:write',
    DocumentsRead = 'documents:read',
    DocumentsDeleteOwned = 'documents:delete_owned',
    DocumentsDeleteLower = 'documents:delete_lower',
    DocumentsDeleteAny = 'documents:delete_any',

    CasesRead = 'cases:read',

    TicketsRead = 'tickets:read',
    TicketsWrite = 'tickets:write',
    TicketsClose = 'tickets:close',
    TicketsExport = 'tickets:export',

    MalwareRead = 'malware:read',
    MalwareWrite = 'malware:write',
    MalwareClose = 'malware:close',

    CompaniesCreate = 'companies:create',
    CompaniesRead = 'companies:read',
    CompaniesEdit = 'companies:edit',
    CompaniesDelete = 'companies:delete',
    CompaniesApprove = 'companies:approve',
    CompaniesMove = 'companies:move',
    CompaniesApproveOffboarding = 'companies:approve_offboarding',

    UsersRead = 'users:read',
    UsersDelete = 'users:delete',
    UsersWrite = 'users:write',
    UsersReset = 'users:reset',

    ContactsRead = 'contacts:read',
    ContactsWrite = 'contacts:write',
    ContactsDelete = 'contacts:delete',

    PaaRead = 'paa:read',
    PaaWrite = 'paa:write',

    DashboardsRead = 'dashboards:read',

    MonthlyReportRead = 'monthly_report:read',
    MonthlyReportWrite = 'monthly_write:write',

    QuestionnaireQuestionWrite = 'questionnaire:question_write',
    QuestionnaireAnswerReview = 'questionnaire:answer_review',
    QuestionnaireAnswerWrite = 'questionnaire:answer_write',
    QuestionnaireQuestionsRead = 'questionnaire:question_read',

    NotificationsSettingsRead = 'notifications_settings:read',
    NotificationsSettingsWrite = 'notifications_settings:write',
}
